<template>
  <figure :class="wrapperClasses" @click="toggleMode">
      <img :src="imgset.src|large" :width="imgset.width" :height="imgset.height" />
      <figcaption>
        <p class="caption">{{caption}}</p>
      </figcaption>
  </figure>
</template>
<script type="text/javascript">

import filters from "../mixins/filters"

export default {
  name: "FigureImage",
  props: {
    imgset: {
      type: Object,
      required: true,
      default: null
    },
    caption: {
      type: String,
      default: ''
    },
  },
  mixins: [filters],
  data() {
    return {
      mode: 'inline'
    }
  },
  computed: {
    aspect() {
      const {width, height} = this.imgset;
      if (height > width) {
        return "portrait"
      } else {
        return "landscape" 
      }
    },
    wrapperClasses() {
      return [this.aspect, this.mode];
    }
  },
  filters: {
    imageKey(val) {
      return "image-" + val;
    }
  },
  methods: {
    toggleMode() {
      this.mode = this.mode === 'inline'? 'full' : 'inline';
    }
  }
};
</script>
